import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// Re-export organized utilities for backwards compatibility
export { formatCoinAmount, formatLastSeen, getDaysUntilDue, getReadingLevel, generateBookCode } from './formatting'
export { playSuccessSound, playButtonClickSound, celebrateAchievement } from './audio'
export { getDueDateStatus, getThemeColorClass } from './status'

/**
 * Merge className utilities
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Child-friendly greeting function
 */
export function getAgeAppropriateGreeting(name: string): string {
  const greetings = [
    `Hi ${name}! 👋`,
    `Hello ${name}! 🌟`,
    `Welcome back ${name}! 📚`,
    `Great to see you ${name}! ✨`,
  ]
  return greetings[Math.floor(Math.random() * greetings.length)]
}

/**
 * Error handling utility
 */
export function getSafeErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message
  }
  return 'Something went wrong. Please try again!'
}

/**
 * Debounce function for event handlers
 */
export function debounce<T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout
  return (...args: Parameters<T>) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), wait)
  }
}